import LabServiceCollection from "../LabServiceCollection";
import NoteModel from "@/models/lab/NoteModel";

export default class NoteCollection extends LabServiceCollection {

    model() {
        return NoteModel;
    }

}